/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Password_MismatchInputs */

const cs_portal_password_mismatch = /** @type {(inputs: Portal_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesla se neshodují.`)
};

const en_portal_password_mismatch = /** @type {(inputs: Portal_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords do not match.`)
};

/**
* | output |
* | --- |
* | "Passwords do not match." |
*
* @param {Portal_Password_MismatchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_password_mismatch = /** @type {((inputs?: Portal_Password_MismatchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Password_MismatchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_password_mismatch(inputs)
	return cs_portal_password_mismatch(inputs)
});